import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { BlogPostEdge, GraphQLBlogPostsData } from "./blog-banner-types"
import "./blog-banner.module.scss"
import { BlogBannerList } from "../BlogBannerList/BlogBannerList"

interface BlogBannerProps {
  eyebrowText: string
  heading: string
  subHeading: string
  parentSlug: string
  relatedArticles: BlogPostEdge[]
}

export const BlogBanner = ({
  heading,
  eyebrowText,
  subHeading,
  relatedArticles,
  parentSlug = "",
}: BlogBannerProps) => {
  const { posts } = useStaticQuery<GraphQLBlogPostsData>(
    getBlogBannerFooterPosts
  )

  return (
    <section className="fr-blog-banner u-content-block-padding">
      <div className="fr-container fr-blog-banner__wrapper">
        {heading && (
          <div className="u-container-header">
            {eyebrowText && (
              <p className="fr-blog-banner__eyebrow">{eyebrowText}</p>
            )}
            <h2 className="fr-blog-banner__heading">
              {relatedArticles.length > 0 ? "Recommended" : heading}
            </h2>

            {relatedArticles.length === 0 && subHeading && (
              <h3>{subHeading}</h3>
            )}
          </div>
        )}

        <BlogBannerList relatedArticles={relatedArticles} posts={posts} />
      </div>
    </section>
  )
}

const getBlogBannerFooterPosts = graphql`
  query getBlogBannerFooterPosts {
    posts: allKontentItemBlogPost(
      sort: { fields: elements___published_date___value, order: DESC }
      limit: 3
    ) {
      edges {
        node {
          id
          elements {
            heading {
              value
            }
            featured_text {
              value
            }
            featured_image {
              value {
                description
                height
                name
                url
                width
              }
            }
            published_date {
              value(formatString: "MMMM DD, YYYY")
            }
            slug {
              value
            }
          }
        }
      }
    }
  }
`

export const query = graphql`
  fragment BlogBannerFragment on kontent_item_global_footer_blog_banner {
    id
    elements {
      eyebrow_text {
        value
      }
      blog_banner_heading {
        value
      }
      sub_heading {
        value
      }
    }
  }
`
